import React, {useContext, useEffect, useState} from "react";
import {Context} from "../../../../App";
import DB_Debts from "../../../../database/dictionary/debts";
import {useTranslation} from "react-i18next";
import ModalWindow from "../../../modal";
import {Outlet, useParams} from "react-router-dom";
import {Breadcrumb, Card, Col, Descriptions, Divider, Row, Skeleton, Space, Table} from "antd";
import BackButton from "../../../tech/back_button";

const Debt = () => {
    const {debt_id} = useParams();
    const {token, user, defaultPageSize, setToken} = useContext(Context)
    const {getDebt} = DB_Debts(token)
    const {t} = useTranslation()
    const {errorConnect} = ModalWindow()
    const [columns, setColumns] = useState([
        {
            title: t('date'),
            dataIndex: 'date',
        },
        {
            title: t('invoice_number'),
            dataIndex: 'invoice_number',
        },
        {
            title: t('pay_form'),
            dataIndex: 'pay_form',
        },
        {
            title: t('invoice_amount'),
            dataIndex: 'invoice_amount',
        },
        {
            title: t('planned_payment_date'),
            dataIndex: 'planned_payment_date',
        },
        {
            title: t('debt'),
            dataIndex: 'debt',
        },
    ])


    const [tradePoint, setTradePoint] = useState({
        trade_point_code: null,
        name: null,
        address: null,
        legal_entity: null,
        branch: null,
        debt: 0
    })
    let [data, setData] = useState({
        trade_point: tradePoint,
        debts: []
    })

    const [wait, setWait] = useState(false)

    useEffect(() => {
        window.scroll(0, 0)
        if (debt_id != null) {
            getDebt(debt_id)
                .then(res => {
                    setData(res.data)

                    // Delete pay_form column if no data in field pay_form
                    let showPayForms = false
                    res.data.debts.map(d => {
                        if(d.pay_form != null) {
                            showPayForms = true
                        }
                    })
                    if (!showPayForms) {
                        setColumns(
                            columns.filter(c => c.dataIndex !== 'pay_form')
                        )
                    }
                    //
                })
                .catch((e) => {
                    if (e.request.status === 403) {
                        setToken(null)
                    } else {
                        errorConnect()
                    }
                })
                .finally(() => {
                    setWait(false)
                })
        }
    }, [])

    return (
        <>
            <div className="page">
                <Space
                    style={{
                        width: '100%',
                        justifyContent: 'space-between'
                    }}>
                    <Breadcrumb
                        style={{
                            margin: '15pt 0',
                        }}
                    >
                        <Breadcrumb.Item>
                            <span className={'ant-page-header-heading-title'} style={{paddingLeft: '24px'}}>
                                {t('debt')}</span>
                        </Breadcrumb.Item>
                    </Breadcrumb>

                    <Space>
                        <BackButton/>
                    </Space>
                </Space>
                <Card
                    title={data.trade_point.name}
                >
                    <Skeleton loading={wait} active>
                        <Descriptions>
                            <Descriptions.Item label={t('code')} span={3}>
                                <span
                                    style={{fontFamily: 'Montserrat-Medium'}}>{data.trade_point.trade_point_code}</span>
                            </Descriptions.Item>

                            <Descriptions.Item label={t('name')} span={3}>
                                    <span
                                        style={{fontFamily: 'Montserrat-Medium'}}>{data.trade_point.name}</span>
                            </Descriptions.Item>

                            <Descriptions.Item label={t('legal_entity')} span={3}>
                                    <span
                                        style={{fontFamily: 'Montserrat-Medium'}}>{data.trade_point.legal_entity}</span>
                            </Descriptions.Item>

                            <Descriptions.Item label={t('address')} span={3}>
                                <span style={{fontFamily: 'Montserrat-Medium'}}>{data.trade_point.address}</span>
                            </Descriptions.Item>

                            <Descriptions.Item label={t('branch')} span={3}>
                                <span style={{fontFamily: 'Montserrat-Medium'}}>{data.trade_point.branch}</span>
                            </Descriptions.Item>

                        </Descriptions>
                    </Skeleton>
                    <Divider/>

                    <Table
                        style={{'--cursor': "auto" }}
                        columns={columns}
                        dataSource={data.debts}
                        rowKey="invoice_number"
                        loading={wait}
                        pagination={{
                            position: ['none', 'none'],
                        }}
                        size={"small"}
                        rowClassName={(record, index) => (record.is_expired ? "red" : null)}
                    />

                    <Card bordered={false}>
                        <Skeleton loading={wait} active>
                            <Row gutter={8}>
                                <Col span={4} offset={16} style={{display: 'flex', justifyContent: 'flex-end'}}>
                                    <p>{t('debt_total')}</p>
                                </Col>
                                <Col span={4} style={{display: 'flex', justifyContent: 'flex-end'}}>
                                    <span style={{fontFamily: 'Montserrat-Medium'}}>{data.trade_point.debt}</span>
                                </Col>
                            </Row>
                        </Skeleton>
                    </Card>
                </Card>
            </div>
            <Outlet/>
        </>
    )
}

export default Debt